import React from 'react';
import { useIntl } from 'react-intl';
import { DictionaryEvidence, Evidence } from '@eas/common-web';
import { useDictionaryEvidence } from '@composite/evidence/dictionary-evidence';
import { useDictionaryHookedSources } from '@components/evidence/dictionary-evidence/dictionary-hooked-sources';
import { DictDispatchType } from '@models';
import {
  EntityName,
  EvidenceApiUrl,
  ExportTags,
  HistoryEntityType,
} from '@enums';
import { Fields } from './dict-dispatch-type-fields';
import { useValidationSchema } from './dict-dispatch-type-schema';

export function DictDispatchTypes() {
  const validationSchema = useValidationSchema();
  const intl = useIntl();
  const { columnName, columnCode, columnActive } =
    DictionaryEvidence.useDictionaryColumns<DictDispatchType>();

  const evidence = useDictionaryEvidence<DictDispatchType>({
    version: 2,
    identifier: 'DISPATCH_TYPES',
    apiProps: {
      url: EvidenceApiUrl.DICT_DISPATCH_TYPES,
      hookedSources: useDictionaryHookedSources({
        entityType: HistoryEntityType.DISPATCH_TYPE,
      }),
    },
    tableProps: {
      columns: [columnName, columnCode, columnActive],
      tableName: intl.formatMessage({
        id: 'ES__DICT_DISPATCH_TYPES__TABLE__TITLE',
        defaultMessage: 'Typy odeslání',
      }),
      reportTag: ExportTags.DICT_DISPATCH_TYPES,
      defaultSorts: [
        { field: 'name', datakey: 'name', order: 'ASC', type: 'FIELD' },
      ],
    },
    detailProps: {
      entityName: EntityName.DISPATCH_TYPE,
      toolbarProps: {
        title: intl.formatMessage({
          id: 'ES__DICT_DISPATCH_TYPES__DETAIL__TITLE',
          defaultMessage: 'Typ odeslání',
        }),
      },
      validationSchema,
      GeneralFieldsComponent: Fields,
    },
  });

  return <Evidence {...evidence} />;
}
